export default __webpack_public_path__ + "static/media/tile-des1-fr-pick-mode.20168a9a.gif";